import { IDeserialize } from "./abstraction/IDeserialize";
import { UnitOfMeasure } from "./Enums";

export default class CustomerSettings implements IDeserialize<CustomerSettings> {
  companyName: string;
  companyId: string;
  shippingAccountId: string;
  isShippingEnabled: boolean;
  isTechCoverEnabled: boolean;
  unitOfMeasure: UnitOfMeasure;
  shippingNotes: string;
  carrier: string;

  deserialize(dto?: CustomerSettings): CustomerSettings {
    if (!dto) return this;

    Object.assign(this, dto);
    return this;
  }

  areShippingSettingsValid(): boolean {
    return !!this.shippingAccountId && !!this.unitOfMeasure;
  }
}
